import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#17266d", dark: "#101a4c", light: "#4f5b98" },
    secondary: { main: "#19acd3", dark: "#087fa2", light: "#66c8e1" },
    warning: { main: "#c5a719" },
    background: { default: "#f5f7fc", paper: "#ffffff" }
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontSize: "2rem", fontWeight: 750 },
    h2: { fontSize: "1.35rem", fontWeight: 750 }
  },
  components: {
    MuiButton: { defaultProps: { size: "small", disableElevation: true }, styleOverrides: { root: { minWidth: 0, height: 32, minHeight: 32, maxHeight: 32, paddingInline: 10, borderRadius: 6, textTransform: "none", fontWeight: 650, fontSize: ".78125rem", whiteSpace: "nowrap" }, sizeMedium: { height: 36, minHeight: 36, maxHeight: 36 }, sizeLarge: { height: 40, minHeight: 40, maxHeight: 40, paddingInline: 16 }, startIcon: { marginLeft: -2, marginRight: 5, "& > :nth-of-type(1)": { fontSize: 17 } } } },
    MuiCard: { defaultProps: { variant: "outlined" }, styleOverrides: { root: { borderColor: "#e2e8f0", borderRadius: 12, boxShadow: "0 2px 8px rgba(15,23,42,.035)" } } },
    MuiCardContent: { styleOverrides: { root: { padding: 18, "&:last-child": { paddingBottom: 18 } } } },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiFormControl: { defaultProps: { size: "small" } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
    MuiTableContainer: { styleOverrides: { root: { borderColor: "#e2e8f0", borderRadius: 12, overflowX: "auto" } } },
    MuiTableCell: { styleOverrides: { root: { borderColor: "#e8edf4", paddingTop: 10, paddingBottom: 10, verticalAlign: "middle" }, head: { backgroundColor: "#f8fafc", color: "#475569", fontWeight: 750, whiteSpace: "nowrap" } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14, maxHeight: "calc(100dvh - 32px)" } } },
    MuiDialogTitle: { styleOverrides: { root: { padding: "18px 20px 10px", fontWeight: 750 } } },
    MuiDialogContent: { styleOverrides: { root: { padding: "10px 20px 18px" } } },
    MuiDialogActions: { styleOverrides: { root: { padding: "10px 20px 18px", gap: 6 } } },
    MuiTabs: { styleOverrides: { root: { minHeight: 38 }, indicator: { height: 3 } } },
    MuiTab: { styleOverrides: { root: { minHeight: 38, paddingTop: 6, paddingBottom: 6, textTransform: "none", fontWeight: 700 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 650 } } }
  }
});
